import { graphql } from '@graphql/__generated'

export const GET_DASHBOARD_EVENTS = graphql(`
  query GetDashboardEvents {
    getDashboardEvents {
      events {
        ...EventOverview
      }
    }
  }
`)
